export const shuffleArray = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};

export const secondsToMMSS = (seconds: number): string => {
    return new Date(seconds * 1000).toISOString().substr(14, 5);
};

export const secondsToHHMMSS = (seconds: number): string => {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
};

export const rangeRandomInt = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min) + min);
};

export const remapValue = (value: number, low1: number, high1: number, low2: number, high2: number): number => {
    return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
};

export function searchParam(key: string): string {
    const query = window.location.search.substring(1);
    const params = query.split('&');
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split('=');
        if (pair[0] === key) {
            return pair[1];
        }
    }
    return '';
};
